<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <nuxt-link to="/rental"> <o-button>Zurück</o-button></nuxt-link>
        <br />
        <br />
        <div class="columns is-multiline">
          <div class="
              column
              is-full-mobile
              is-half-tablet
              is-half-desktop
              is-one-third-widescreen
              is-one-third-fullhd
            " v-for="(image, index) in images" v-bind:key="index">
            <div class="card">
              <div class="card-image">
                <figure class="image is-4by3">
                  <img :src="`/img/rental/${image}`" style="object-fit: cover" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const config = useRuntimeConfig();
useSeoMeta({
    title: `${config.public.meta.fullTitle}`,
    ogTitle: `Kontakt - ${config.public.meta.fullTitle}`,
    description: config.public.meta.description,
    ogDescription: config.public.meta.description,
    ogImage: config.public.meta.image
});
const images: string[] = [
  "night.jpeg",
  "front.jpeg",
  "corridor.jpeg",
  "big_room.jpeg",
  // "thing.jpeg",
  "above.jpeg",
  "kitchen.jpeg",
  "back.jpeg",
];
</script>